<template>
  <div style="padding-top: 1rem">
    <!--<navTitle title="游戏榜单"></navTitle>-->
    <navTitle :title="$router.app._route.query.ti ? $router.app._route.query.ti : 'List of games'"></navTitle>

    <div class="list">
      <div class="li" v-for="item in list" @click="$router.push({ path: '/user/rank', query: { game_id: item.id } })">
        {{ item.name }}
        <div class="iconfont icon-xiangyou" style="color: #666"></div>
      </div>
    </div>
  </div>
</template>

<script>
import navTitle from "@components/navTitle";
import { game_list } from "@api/game";
import { gameEcharts } from "@components/gameEcharts";

export default {
  name: "rank",
  components: {
    navTitle,
    // gameEcharts
  },
  data: function() {
    return {
      list: []
    };
  },
  methods: {
    getList() {
      game_list().then(res => {
        this.list = res.data;
      });
    }
  },
  mounted() {
    this.getList();
  }
};
</script>

<style scoped>
.list {
  width: 100%;
  margin: 0;
  position: relative;
  padding-top: 0.2rem;
}
.list .li {
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  padding: 0 0.3rem;
  box-sizing: border-box;
  background: #fff;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
}
</style>
